import type { JSX } from 'preact';
import * as stylex from '@stylexjs/stylex';
import { SearchIcon } from '@xantory/icons';
import { styles } from './search.styles';
import { useT } from '@xantory/i18n';
interface SearchProps extends Omit<JSX.IntrinsicElements['input'], 'ref' | 'type'> {
  /** Which surface this sits on. `raised` (default) is a white field on the page
   *  background. `sunken` is for a field inside an ALREADY-white container — the
   *  sidebar — where a white field is invisible until it gains focus. */
  tone?: 'raised' | 'sunken';
}
export function Search({
  placeholder,
  tone = 'raised',
  ...rest
}: SearchProps) {
  const t = useT('ui');
  return <div {...stylex.props(styles.wrap)}>
      <SearchIcon {...stylex.props(styles.icon)} />
      <input type="search" data-dirty-ignore placeholder={placeholder ?? t('searchPlaceholder')} {...rest} {...stylex.props(styles.input, tone === 'sunken' && styles.inputSunken)} />
    </div>;
}